import React, { useState, useEffect, useContext } from 'react';
import { withRouter, Switch, Route, Redirect } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import GenericListPair from 'modules/common/components/GenericListPair';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import * as actions from '../action';
import * as c from '../constant';
import BirthCertificateSettingsContent from './BirthCertificateSettingsContent';
import useDebounce from '../../../../../../common/hooks/useDebounce';
import UpdateModal from '../components/UpdateModal';

const form = {
  q: '',
};

function BirthCertificateSettingsContainer({
  match,
  history,
  getBirthCertificateSettings,
  birthCertificateSettings,
  birthCertificateSettingsPager,
  isLoading,
}) {
  const [formData, setFormData] = useState(form);
  const setModal = useContext(ModalContext);

  const handleOnChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e ? e.target.value : '',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <UpdateModal updateList={data.attributes} id={data.id} />,
      title: 'Update Birth Certificate Settings',
      modalSize: 'modal-md',
    });
  };

  const param = {
    q: formData.q,
    sort_by: 'asc',
  };

  useEffect(() => {
    getBirthCertificateSettings();
    return () => {
      setModal({ isOpen: false });
    };
  }, []);

  const debouncedSearchTerm = useDebounce(formData, 500);

  useEffect(() => {
    if (debouncedSearchTerm) {
      getBirthCertificateSettings({ q: formData.q, sort_by: 'asc' });
    } else {
      setFormData([]);
    }
  }, [debouncedSearchTerm]);

  return (
    <div className="card-content-listing">
      <Route
        path={`${match.path}/:settingsId?`}
        render={({ match: { params } }) => (
          <GenericListPair
            setParams={param}
            moduleName="Settings"
            getData={getBirthCertificateSettings}
            setKeyword={handleOnChange}
            keyword={_.get(formData, 'q') || ''}
            keywordPlaceholder="Search..."
            pathName={`${match.path}/:settingsId?`}
            listName="Transaction"
            label="List"
            renderItem={(item) => (
              <div className="px-3 py-3 text-uppercase">
                <span>
                  {' '}
                  {_.get(item, 'attributes.name', '').toUpperCase()}{' '}
                </span>
              </div>
            )}
            isLoading={isLoading}
            selected={params.settingsId}
            data={birthCertificateSettings}
            dataPager={birthCertificateSettingsPager}
            handleSelectRow={(data) => {
              history.push(`${match.url}/${_.get(data, 'id')}`);
            }}
            renderContent={() => (
              <React.Fragment>
                <Switch>
                  <Route
                    path={`${match.path}/:settingsId?`}
                    render={() => (
                      <BirthCertificateSettingsContent
                        handleEdit={handleEdit}
                      />
                    )}
                  />
                </Switch>
                <Route
                  path={`${match.path}/:settingsId?`}
                  render={() =>
                    !params.settingsId &&
                    birthCertificateSettings.length > 0 ? (
                      <Redirect
                        to={`${match.url}/${_.get(
                          birthCertificateSettings,
                          '0.id'
                        )}`}
                      />
                    ) : null
                  }
                />
              </React.Fragment>
            )}
          />
        )}
      />
    </div>
  );
}

BirthCertificateSettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getBirthCertificateSettings: PropTypes.instanceOf(Function).isRequired,
  birthCertificateSettings: PropTypes.instanceOf(Array).isRequired,
  birthCertificateSettingsPager: PropTypes.instanceOf(Object).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  birthCertificateSettings:
    _.get(api, `${c.GET_BIRTH_CERTIFICATE_SETTINGS}.list`) || [],
  birthCertificateSettingsPager:
    _.get(api, `${c.GET_BIRTH_CERTIFICATE_SETTINGS}.pager`) || {},
  isLoading:
    _.get(api, 'loading', []).indexOf(c.GET_BIRTH_CERTIFICATE_SETTINGS) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(BirthCertificateSettingsContainer);
